export default "__VITE_ASSET__09af1163__"